"use strict";

var _interopRequireDefault = require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dateFormat = dateFormat;
exports.getDateRegion = getDateRegion;
exports.getTime = getTime;
exports.isMaxDate = isMaxDate;
exports.parseTime = parseTime;
require("core-js/modules/es7.string.pad-start");
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.regexp.to-string");
var _typeof2 = _interopRequireDefault(require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/typeof.js"));
/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} fmt
 * @returns {string | null}
 */
function parseTime(time, fmt) {
  if (arguments.length === 0) {
    return null;
  }
  if (time === 0) return null;
  fmt = fmt || '{y}-{m}-{d}';
  var date;
  if ((0, _typeof2.default)(time) === 'object') {
    date = time;
  } else {
    if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
      time = parseInt(time);
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  var formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  return fmt.replace(/{([ymdhisa])+}/g, function (result, key) {
    var value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value];
    }
    return value.toString().padStart(2, '0');
  });
}
function getTime() {
  var fmt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '{y}-{m}-{d}';
  var time = new Date().getTime();
  return parseTime(time, fmt);
}

/**
 * 判断是否是最大日期
 * @param {string} date
 */
function isMaxDate(date) {
  var diffTime = new Date(date).getTime();
  var now = new Date(getTime()).getTime();
  return diffTime > now;
}

/**
 * 获取日期区间
 * @param {*} startDate 开始日期
 * @param {*} endDate 结束日期
 */
function getDateRegion(startDate, endDate) {
  var date_region = [];
  var start_time = new Date(startDate).getTime();
  var end_time = new Date(endDate).getTime();
  while (start_time <= end_time) {
    date_region.push(parseTime(start_time));
    start_time += 24 * 3600 * 1000;
  }
  return date_region;
}
function dateFormat(date) {
  date = date.toString();
  return "".concat(date.slice(0, 4), "-").concat(date.slice(4, 6), "-").concat(date.slice(6));
}